import Turf from 'lib/Turf';

// Marge métier alignée sur ZoneList.getClosest (distance <= 0.5 km)
var EXPAND_M = 500;

/**
 * Calcule la bbox d'un geojson élargie de 500 m.
 * @param {object} geojson Geometry GeoJSON
 * @returns {{ minLng, minLat, maxLng, maxLat }|null}
 */
export function computeExpandedBounds( geojson )
{
	// Pas de géométrie → pas de bounds
	if( !geojson )
	{
		return null;
	}

	var bbox;

	// Calcul de la bbox via Turf (ou fallback manuel)
	try
	{
		bbox = Turf.bbox( geojson );
	}
	catch( e )
	{
		console.warn( 'computeExpandedBounds', e );
		return null;
	}

	if( !bbox || bbox.length < 4 )
	{
		return null;
	}

	var midLat = ( bbox[1] + bbox[3] ) / 2;
	var cosLat = Math.cos( midLat * Math.PI / 180 );
	var dLat = EXPAND_M / 111320;
	var dLng = cosLat === 0 ? dLat : EXPAND_M / ( 111320 * Math.abs( cosLat ) );

	return {
		minLng: bbox[0] - dLng,
		minLat: bbox[1] - dLat,
		maxLng: bbox[2] + dLng,
		maxLat: bbox[3] + dLat,
	};
}

/**
 * Teste si un point est dans les bounds élargis.
 */
export function boundsContain( bounds, lat, lng )
{
	if( !bounds )
	{
		return false;
	}

	return lng >= bounds.minLng && lng <= bounds.maxLng
		&& lat >= bounds.minLat && lat <= bounds.maxLat;
}
